export default __webpack_public_path__ + "static/media/Failed.e06e3ceb.gif";